"use client";

import { type ReactNode, useEffect } from "react";

import posthog from "posthog-js";

interface CaptureErrorProps {
  children: ReactNode;
  error: { digest?: string } & Error;
}
export const CaptureError = (props: CaptureErrorProps) => {
  const { children, error } = props;

  useEffect(() => {
    posthog.captureException(error);
  }, [error]);

  return children;
};
